import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { settingsService } from '../../services/api'

const initialState = {
  general: {},
  email: {},
  whatsapp: {},
  shipment: {},
  loading: false,
  error: null
}

export const fetchGeneralSettings = createAsyncThunk(
  'settings/fetchGeneralSettings',
  async (_, { rejectWithValue }) => {
    try {
      const response = await settingsService.getGeneralSettings()
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch settings')
    }
  }
)

export const updateGeneralSettings = createAsyncThunk(
  'settings/updateGeneralSettings',
  async (settings, { rejectWithValue }) => {
    try {
      const response = await settingsService.updateGeneralSettings(settings)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update settings')
    }
  }
)

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGeneralSettings.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchGeneralSettings.fulfilled, (state, action) => {
        state.loading = false
        state.general = action.payload
      })
      .addCase(fetchGeneralSettings.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      
      .addCase(updateGeneralSettings.fulfilled, (state, action) => {
        state.general = action.payload
      })
  }
})

export const { clearError } = settingsSlice.actions
export const selectGeneralSettings = (state) => state.settings.general
export const selectSettingsLoading = (state) => state.settings.loading
export const selectSettingsError = (state) => state.settings.error

export default settingsSlice.reducer 